<template>
  <div class="mt-0-px pb-0" v-if="isExtern != null ? !isExtern && !isEtfSingleOnly : false">
    <div id="startseite" v-if="angemeldeterMitarbeiter">
      <navigation-arvea :angemeldeterMitarbeiter="angemeldeterMitarbeiter" />
      <div class="universeContainer mt-5">
        <universe-overview />
      </div>
    </div>
  </div>
</template>

<script>
import page from "@/mixins/Page";
import store from "@/store";
import NavigationArvea from "@/components/Navigation/NavigationArvea";
import UniverseOverview from "@/components/charts/UniverseOverview";

export default {
  name: "StartseiteArvea",
  components: {
    NavigationArvea,
    UniverseOverview
  },
  mixins: [page],
  store,
  metaInfo() {
    return {
      titleTemplate: () => {
        return "Arvea Universe Calculator";
      }
    };
  },
  data() {
    return {};
  },
  computed: {
    isExtern() {
      if (!this.angemeldeterMitarbeiter) return null;
      if (this.angemeldeterMitarbeiter.gruppen[0] === "extern") {
        return true;
      } else return false;
    }
  }
};
</script>

<style lang="scss">
body {
  background: white;
  color: #213056;
  overflow-x: hidden;
}
.universeContainer {
  max-width: calc(100vw - 15%);
  margin: 0 auto;
  padding: 50px 0;
}
</style>
